
import { createElement } from 'react';
import Wrapper from './wrapper';


export const AuthenticatedPage = ({ children }) => {
    const computedChildren = Array.isArray(children) ? children : [children];
    return createElement(Wrapper, { children: computedChildren });
};

export default AuthenticatedPage;
